import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">编辑推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            编辑部精选优质漫画，每周更新推荐列表
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-heading text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}